import FlexColumn from "@/components/FlexColumn.vue";
import FlexRow from "@/components/FlexRow.vue";
import AppIconGroup from "@/components/AppIconGroup.vue";
import TableSkeletonV2 from '@/components/TableSkeletonV2.vue';
import ViewExportDropdown from "@/components/ViewExportDropdown.vue";
import BarLineChartIcon from "@/components/icons/BarLineChartIcon.vue";
import WrapWithHighlight from "@/components/WrapWithHighlight.vue";
import WrapWithPopover from "@/components/shared/WrapWithPopover.vue";
export default {
  name: 'TableWithTitle',
  components: {
    FlexColumn,
    FlexRow,
    AppIconGroup,
    TableSkeletonV2,
    ViewExportDropdown,
    BarLineChartIcon,
    WrapWithHighlight,
    WrapWithPopover
  },
  emits: ['download', 'chart-modal-open'],
  props: {
    title: {
      type: String,
      required: true
    },
    gap: {
      type: Number,
      default: 16
    },
    loading: {
      type: Boolean,
      default: true
    },
    fields: {
      type: Boolean
    },
    noDownload: {
      type: Boolean,
      default: false
    },
    customStyles: {
      type: Object,
      default: () => {}
    }
  }
};